import { render, staticRenderFns } from "./StatementRelocation.vue?vue&type=template&id=57ef4f32&"
import script from "./StatementRelocation.vue?vue&type=script&lang=js&"
export * from "./StatementRelocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports